import { useDispatch } from 'react-redux';
import type { SelectProps } from 'core/components';
import { documentsActions } from 'core/store';
import { useEffect, useState } from 'react';
import { usePrevious } from 'react-use';
import type { ResourceUserRoles } from '../../base';
import { RolesSelect } from './RolesSelect';
import type { DocumentAccessManager } from '../../hooks';
import type { DocumentId, UserId } from '../../types';

const { updateDocumentAccess } = documentsActions;

type UpdateDocumentAccessRolesProps = {
  docId: DocumentId;
  userId: UserId;
  accessManager: DocumentAccessManager;
  selectProps: SelectProps;
};

export function UpdateDocumentAccessRoles({
  docId,
  userId,
  accessManager,
  selectProps,
}: UpdateDocumentAccessRolesProps) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const prevValue = usePrevious<string | undefined>(selectProps.value);

  useEffect(() => {
    if (prevValue !== selectProps.value) {
      setLoading(false);
    }
  }, [selectProps.value]);

  const onChange = (value: ResourceUserRoles) => {
    setLoading(true);
    const request = accessManager.updateForUsers([userId], value);
    dispatch(updateDocumentAccess({ id: docId, request }));
  };

  return <RolesSelect loading={loading} onChange={onChange} {...selectProps} />;
}
